// App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { VideoProvider } from "./context/VideoContext";
import Layout from "./components/Layout/Layout";
import AuthGuard from "./components/auth/AuthGuard";
import GoogleOAuthHandler from "./components/auth/GoogleOAuthHandler";
import PaymentVerification from "./components/Purchase/PaymentVerification";
import SubscriptionPage from "./pages/SubscriptionPage/SubscriptionPage";
import DeleteAccountPage from "./pages/DeleteAccountPage/DeleteAccountPage";
import "./App.css";
import { ShadowTechniqueProvider } from "./context/ShadowTechniqueContext";
import { SubtitleSettingsProvider } from "./context/SubtitleSettingsContext";
import { NotificationProvider } from "./context/NotificationContext";
import { SelectedSubtitlesProvider } from "./context/SelectedSubtitlesContext";
import { PackagesModalProvider } from "./context/PackagesModalContext";
import { ThemeProvider } from "./context/ThemeContext";
import Comparesrt from "./components/Comparesrt/Comparesrt";

function App() {
  return (
    <ThemeProvider>
    <Router>
      <VideoProvider>
        <SubtitleSettingsProvider>
          <ShadowTechniqueProvider>
            <NotificationProvider>
              <SelectedSubtitlesProvider>
                <PackagesModalProvider>
                  <Routes>
                    <Route
                      path="/googlelogin"
                      element={<GoogleOAuthHandler />}
                    />
                  </Routes>
                  <AuthGuard>
                    <Routes>
                      <Route path="/" element={<Layout />} />
                      <Route
                        path="/payment/verify/:orderId"
                        element={<PaymentVerification />}
                      />
                      <Route
                        path="/Subscription"
                        element={<SubscriptionPage />}
                      />
                      <Route path="/comparesrt" element={<Comparesrt />} />
                      <Route
                        path="/deleteaccount"
                        element={<DeleteAccountPage />}
                      />
                    </Routes>
                  </AuthGuard>
                </PackagesModalProvider>
              </SelectedSubtitlesProvider>
            </NotificationProvider>
          </ShadowTechniqueProvider>
        </SubtitleSettingsProvider>
      </VideoProvider>
    </Router>
    </ThemeProvider>
  );
}

export default App;
